export default __webpack_public_path__ + "static/media/Terrain de basket.571e245a.svg";